<script>
    export let routeId;
    export let title;
</script>

<div class="node-icon not-visited">
    <span class="node-icon-connector"></span>
</div>
<p class="tracker-node-title">{title}</p>

<style>
    .tracker-node-title {
        font-size: 0.8571428571428571rem;
        font-weight: 400;
        line-height: 1.5;
        margin: 0;
    }
</style>